/**
 * Collection Hero Parallax - Desktop Only
 * Layered speed parallax + 3D rotation on "DISTURBS"
 */

(function() {
  'use strict';

  // Only run on desktop
  if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) {
    return;
  }

  class HeroParallax {
    constructor(hero) {
      this.hero = hero;
      this.label = hero.querySelector('.collection-editorial-hero__label');
      this.headline = hero.querySelector('.collection-editorial-hero__headline');
      this.accent = hero.querySelector('.collection-editorial-hero__accent');
      this.pills = hero.querySelector('.collection-editorial-hero__pills');

      this.heroTop = 0;
      this.heroHeight = 0;

      this.init();
    }

    init() {
      if (!this.label || !this.headline || !this.pills) {
        return;
      }

      this.calculateBounds();
      this.setupScrollListener();
    }

    calculateBounds() {
      const rect = this.hero.getBoundingClientRect();
      this.heroTop = rect.top + window.scrollY;
      this.heroHeight = rect.height;
    }

    setupScrollListener() {
      let ticking = false;

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.updateParallax();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', () => {
        this.calculateBounds();
      });

      // Initial update
      this.updateParallax();
    }

    updateParallax() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Only apply parallax when hero is in/near viewport
      if (scrollY > this.heroTop + this.heroHeight + windowHeight) return;

      // Calculate scroll progress relative to hero position
      const scrollProgress = scrollY - this.heroTop;

      // Layered Speed Parallax
      // Label moves fastest (1.5x speed)
      const labelOffset = scrollProgress * 0.5; // 1.5x = base + 0.5x extra
      this.label.style.transform = `translateY(${labelOffset}px)`;

      // Headline moves at normal speed (1x) - no additional transform needed

      // Pills move slowest (0.5x speed)
      const pillsOffset = scrollProgress * -0.5; // negative = lags behind
      this.pills.style.transform = `translateY(${pillsOffset}px)`;
    }
  }

  // Initialize on collection pages
  function init() {
    // Only run on collection pages
    if (!document.querySelector('[data-template="collection"]')) {
      return;
    }

    const hero = document.querySelector('.collection-editorial-hero');
    if (!hero) {
      return;
    }

    // Wait for layout to settle
    setTimeout(() => {
      new HeroParallax(hero);
    }, 300);
  }

  // DOM ready check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
